import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={0.5} width={35} height={23} fill="white" />
      <rect x={0.5} y={0.5} width={35} height={23} stroke="#E2E8F0" />
      <path
        d="M10.4303 9.05035H5.99505C5.41746 9.05035 4.94971 9.52217 4.94971 10.1046V14.5768C4.94971 15.1589 5.41746 15.6309 5.99505 15.6309H10.4303C11.0077 15.6309 11.4753 15.1589 11.4753 14.5768V10.1046C11.4753 9.52217 11.0077 9.05035 10.4303 9.05035Z"
        fill="#1677FF"
      />
      <path
        d="M6.71252 14.1109C5.69732 14.1109 5.39718 13.3046 5.89889 12.8634C6.06632 12.7143 6.37225 12.6415 6.53536 12.6251C7.13841 12.5651 7.69665 12.7971 8.35543 13.1213C7.89237 13.7305 7.30257 14.1109 6.71252 14.1109ZM10.322 13.1825C10.0609 13.0943 9.71047 12.9594 9.32021 12.817C9.55458 12.4062 9.74179 11.9383 9.86483 11.4298H8.57852V10.9626H10.1542V10.7018H8.57852V9.92296H7.93546C7.82265 9.92296 7.82265 10.0353 7.82265 10.0353V10.7018H6.22899V10.9626H7.82265V11.4298H6.50688V11.6905H9.05878C8.96539 12.015 8.84001 12.3196 8.6912 12.5963C7.86315 12.3208 6.97956 12.0975 6.42446 12.2349C6.06946 12.3231 5.84082 12.4806 5.7065 12.6455C5.09001 13.4019 5.53218 14.5508 6.83414 14.5508C7.60394 14.5508 8.34551 14.118 8.92027 13.4047C9.77754 13.8203 11.4748 14.5338 11.4748 14.5338V13.5169C11.4748 13.5169 11.2617 13.4998 10.322 13.1825Z"
        fill="white"
      />
      <path
        d="M19.1196 10.0143C19.1196 10.3548 19.3684 10.584 19.7155 10.584C20.0625 10.584 20.3113 10.3548 20.3113 10.0143C20.3113 9.68042 20.0625 9.44463 19.7155 9.44463C19.3684 9.44463 19.1196 9.68042 19.1196 10.0143Z"
        fill="#1677FF"
      />
      <path
        d="M17.4556 14.3692H18.4901V9.58984H17.4556V14.3692Z"
        fill="currentcolor"
      />
      <path
        d="M14.1357 12.7127L14.7511 10.5849H14.7774L15.3601 12.7127H14.1357ZM15.6417 9.7534H14.2535L12.7017 14.3691H13.6577L13.9196 13.4656H15.5631L15.8119 14.3691H17.0364L15.6417 9.7534Z"
        fill="currentcolor"
      />
      <path
        d="M19.1982 14.369H20.2328V10.8594H19.1982V14.369Z"
        fill="currentcolor"
      />
      <path
        d="M31.0436 10.8647L31.0501 10.8582H30.0745L29.459 12.9925H29.4263L28.7191 10.8582H27.5601L28.9549 14.3806L28.3721 15.4543V15.4805H29.2822L31.0436 10.8647Z"
        fill="currentcolor"
      />
      <path
        d="M22.1519 13.7651C22.0341 13.7651 21.9227 13.7521 21.7984 13.7127V11.8141C22.0144 11.6635 22.1912 11.5915 22.4138 11.5915C22.8002 11.5915 23.1079 11.8992 23.1079 12.5539C23.1079 13.3919 22.6561 13.7651 22.1519 13.7651ZM22.8067 10.7862C22.4269 10.7862 22.1323 10.9303 21.7984 11.2052V10.8582H20.7637V15.4805H21.7984V14.3347C21.9947 14.3871 22.1781 14.4133 22.4007 14.4133C23.324 14.4133 24.1556 13.7324 24.1556 12.5212C24.1556 11.4344 23.5531 10.7862 22.8067 10.7862Z"
        fill="currentcolor"
      />
      <path
        d="M26.3216 13.5181C26.0466 13.6687 25.8893 13.7276 25.7061 13.7276C25.4573 13.7276 25.3002 13.564 25.3002 13.3021C25.3002 13.2038 25.3198 13.1056 25.3983 13.0271C25.5228 12.9026 25.7651 12.8109 26.3216 12.68V13.5181ZM27.3561 13.4919V12.0252C27.3561 11.2263 26.8848 10.7877 26.0532 10.7877C25.5228 10.7877 25.1561 10.8793 24.4882 11.0823L24.6715 11.8877C25.2804 11.6127 25.549 11.4948 25.8305 11.4948C26.1711 11.4948 26.3216 11.7371 26.3216 12.1103V12.1365C25.1364 12.3592 24.7697 12.4836 24.5405 12.7127C24.3703 12.883 24.2983 13.1253 24.2983 13.4068C24.2983 14.0812 24.8222 14.4414 25.3133 14.4414C25.6799 14.4414 25.9745 14.3039 26.374 14.0026L26.446 14.3693H27.4806L27.3561 13.4919Z"
        fill="currentcolor"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-alipay" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
